import { validateRequired } from ".";

export const validateRequiredIf = (value: string | number | undefined | null, isRequired: () => boolean): boolean => {
	if (!isRequired()) {
		return true;
	}

	return validateRequired(value);
};
